import type { DefaultValues, SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';

import type { IContentBlockFormBodyProps } from '~/components/molecules/ContentBlock';
import type { IContainerProps } from '~/components/utils/Container';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { useFormAutoFocus } from '~/hooks/useFormAutoFocus';
import { UserContentReviewNotifyFormMainSection } from './UserContentReviewNotifyFormMainSection';

export type IUserContentReviewNotifyFormValues = {
  date?: string;
  title?: string;
  content?: string;
};

export type IUserContentReviewNotifyFormProps = IContainerProps &
  Omit<
    IContentBlockFormBodyProps<IUserContentReviewNotifyFormValues>,
    'form' | 'children' | 'onSubmit' | 'submitting'
  > & {
    defaultValues?: DefaultValues<IUserContentReviewNotifyFormValues>;
    onSubmit?: SubmitHandler<IUserContentReviewNotifyFormValues>;
  };

export const UserContentReviewNotifyForm: React.FC<
  IUserContentReviewNotifyFormProps
> = (props) => {
  const { defaultValues, ...other } = props;

  const form = useForm<IUserContentReviewNotifyFormValues>({
    defaultValues,
  });
  useFormAutoFocus({ form, name: 'title' });

  return (
    <ContentBlock.FormBody form={form} {...other}>
      <UserContentReviewNotifyFormMainSection form={form} />
    </ContentBlock.FormBody>
  );
};
